module.exports = __webpack_public_path__ + "assets/star_popular_yellow-e8c6db.svg";